import objectAssign from 'object-assign';
import { GET_BASKET_ITEMS, ADD_ITEM, UPDATE_ITEM,
        DELETE_ITEM, SET_WIZARD_STEP, ORDER_FAILED, ORDER_SUCCESSFUL } from './../actions/basket-actions';

import WizardSteps from '../pages/basket/wizard-steps';

function sumEUR( items ) {
    return  items.reduce( ( sum, {qty, product: {price}} ) => sum + qty * ( price ).toFixed( 2 ), 0 );
}

function sumCZK( items ) {
    return  items.reduce( ( sum, {qty, product: {priceCZK}} ) => sum + qty * ( priceCZK ).toFixed( 2 ), 0 );
}

function sumEURWithVat( items ) {
    return  items.reduce( ( sum, {qty, product: {priceWithVat}} ) => sum + qty * ( priceWithVat ).toFixed( 2 ), 0 );
}

function sumCZKWithVat( items ) {
    return  items.reduce( ( sum, {qty, product: {priceCZKWithVat}} ) => sum + qty * ( priceCZKWithVat ).toFixed( 2 ), 0 );
}

export default function ( state = ( typeof basketReducerState !== 'undefined' ? basketReducerState : {} ), action ) {
    let items = null;

    switch ( action.type ) {
        case GET_BASKET_ITEMS:
            items = action.payload;
            return objectAssign( { }, state, {
                items,
                totalPrice: sumEUR( items ),
                totalPriceWithVat: sumEURWithVat( items ),
                totalPriceCZK: sumCZK( items ),
                totalPriceCZKWithVat: sumCZKWithVat( items )
            } );
            break;
        case ADD_ITEM:
            items = [ action.payload, ...state.items ];
            return objectAssign( { }, state, {
                items,
                totalPrice: sumEUR( items ),
                totalPriceWithVat: sumEURWithVat( items ),
                totalPriceCZK: sumCZK( items ),
                totalPriceCZKWithVat: sumCZKWithVat( items )
            } );
            break;
        case UPDATE_ITEM:
            items = state.items.map( item => item.catalogNumber === action.payload.catalogNumber ? action.payload : item );
            return objectAssign( { }, state, {
                items,
                totalPrice: sumEUR( items ),
                totalPriceWithVat: sumEURWithVat( items ),
                totalPriceCZK: sumCZK( items ),
                totalPriceCZKWithVat: sumCZKWithVat( items )
            } );
            break;
        case DELETE_ITEM:
            items = state.items.filter( item => item.catalogNumber !== action.payload );
            return objectAssign( { }, state, {
                items,
                totalPrice: sumEUR( items ),
                totalPriceWithVat: sumEURWithVat( items ),
                totalPriceCZK: sumCZK( items ),
                totalPriceCZKWithVat: sumCZKWithVat( items )
            } );
            break;
        case SET_WIZARD_STEP:
            return objectAssign( { }, state, {
                wizardStep: action.payload
            } );
            break;
        case ORDER_FAILED:
            return objectAssign( { }, state, {
                wizardStep: WizardSteps.ORDER_FAILED,
                errorCode: action.payload
            } );
            break;

        default:
            return state;

}

}
